import React from 'react';

import { LEG_OVERVIEW_COLUMN_CLASSNAME_MAP } from './legOverview.const';
import { IRouteOverviewHeadCell } from './useRouteOverviewColumns';

const PLACEHOLDER: Record<string, string> = {
    id: 'WAL-TC3B-2732',
    routeType: '3 Stops',
    carrier: 'Carrier Name',
    status: 'Dispatched',
    type: 'Dry Van',
    origin: 'Vaughan, ON',
    destination: 'Edison, NJ',
    mode: 'Road',
    pickup_date: 'Oct 1st, 2026 @ 05:00',
    delivery_date: 'Oct 5th, 2026 @ 05:00',
    description: '1 Dropoff, 2 Pickups',
};

/** Skeleton row — mirrors the visible head cells so widths never jump when real rows arrive. */
const LegOverviewLoaderRow = ({ headCells = [] }: { headCells?: IRouteOverviewHeadCell[] }) => (
    <>
        <td className={`${LEG_OVERVIEW_COLUMN_CLASSNAME_MAP.checkbox} sticky left-0 bg-inherit z-[1] table-cell-with-tooltip`}>
            <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                <div className="custom-loading w-4 h-4 rounded flex-none" />
            </div>
        </td>
        {headCells
            .filter((cell) => cell.id !== 'checkbox' && cell.visible !== false)
            .map((cell) => (
                <td key={cell.id} className={LEG_OVERVIEW_COLUMN_CLASSNAME_MAP[cell.id] || ''}>
                    <span className="custom-loading rounded-md">{PLACEHOLDER[cell.id] || 'Loading'}</span>
                </td>
            ))}
    </>
);

export default LegOverviewLoaderRow;
